import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12.468 24.708a.503.503 0 0 1-.367-.16l-2.667-2.875a.5.5 0 0 1 .026-.706l3.449-3.208a.5.5 0 0 1 .703.022l1.255 1.322A9.113 9.113 0 0 0 17 17c.77-1.079 1.124-2.23 1.263-2.801l-1.502-.688a.5.5 0 0 1-.253-.647l1.75-4.182a.498.498 0 0 1 .651-.269l3.628 1.498a.5.5 0 0 1 .308.418c.018.195.39 4.824-2.589 8.995-2.979 4.172-7.478 5.322-7.668 5.369a.493.493 0 0 1-.12.015m-1.961-3.349 2.117 2.282c.997-.315 4.467-1.605 6.817-4.899 2.345-3.283 2.445-6.971 2.42-8.03l-2.873-1.187-1.371 3.276 1.425.652a.5.5 0 0 1 .286.529c-.012.077-.297 1.891-1.515 3.596-1.212 1.696-2.709 2.566-2.772 2.603a.5.5 0 0 1-.612-.09l-1.201-1.266-2.721 2.532"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.744 13.557a.5.5 0 0 1-.453-.287c-.455-.966-.507-2.052-.146-3.058s1.093-1.81 2.06-2.265a.501.501 0 0 1 .426.906c-.725.341-1.273.944-1.544 1.698s-.232 1.568.109 2.293a.5.5 0 0 1-.452.713"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.935 14.41a.5.5 0 0 1-.453-.287 5.955 5.955 0 0 1-.219-4.588 5.958 5.958 0 0 1 3.089-3.397.5.5 0 1 1 .426.904 4.967 4.967 0 0 0-2.574 2.832 4.964 4.964 0 0 0 .183 3.823.5.5 0 0 1-.452.713"
      })]
    })
  }));
};
export default SvgComponent;